const CustomFormIds = {
    TRIST_KEY_FIN_IND: "TRIST_KEY_FIN_IND",
    TRIST_BASE_COMP: "TRIST_BASE_COMP",
}

export default CustomFormIds;